import React, { useEffect, useState } from "react"
import OrganizationRow from "./OrganizationRow"
import { Button } from "react-bootstrap";
import OrganizationDuplicate from "./OrganizationDuplicate";

export default function OrganizationsTable({ organizations, onDeleteOrganization, mergeInfo }) {
  const [selectedOrganizations, setSelectedOrganizations] = useState([]);
  const [showMergeModal, setShowMergeModal] = useState(false);
  const handleRowInputCheck = (id) => {
    setSelectedOrganizations(prev => {
      const is_exist = prev.find(o => o.id == id)
      if(is_exist) return prev.filter(x => x.id !== id);

      const org = organizations.find(o => o.id == id);
      return [...prev, org]
    })
  }
  useEffect(() => {
    if(!mergeInfo) setSelectedOrganizations([])
  }, [mergeInfo])
  return (
    <div className="table-responsive">
      {selectedOrganizations.length > 0 && <Button variant="outlined-blue" size="sm" onClick={() => setShowMergeModal(true)}>Merge</Button>}
      {showMergeModal && <OrganizationDuplicate organizations={selectedOrganizations} setShowMergeModal={setShowMergeModal} />}
      <table className="table table-listing table-hover">
        <thead>
          <tr>
            {mergeInfo && <th></th>}
            <th>Organisation Name</th>
            <th>Email</th>
            <th>Account Type</th>
            <th>Address</th>
            <th>Related Jobs</th>
          </tr>
        </thead>
        <tbody>
          {organizations.map(organization => <OrganizationRow key={`table-row-${organization.id}`} organization={organization} onDeleteOrganization={onDeleteOrganization} handleRowInputCheck={handleRowInputCheck} selectedOrganizations={selectedOrganizations} mergeInfo={mergeInfo} />)}
        </tbody>
      </table>
    </div>
  )
}
